import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OnboardingImplementationHomeComponent } from './components/onboarding-implementation-home/onboarding-implementation-home.component';
import { OnboardingImplementationSellerPullComponent } from './components/onboarding-implementation-seller-pull/onboarding-implementation-seller-pull.component';
import { OnboardingImplementationSellerPushComponent } from './components/onboarding-implementation-seller-push/onboarding-implementation-seller-push.component';

const routes: Routes = [
  {
    path: '',
    component: OnboardingImplementationHomeComponent,
  },
  {
    path: 'seller-pull',
    component: OnboardingImplementationSellerPullComponent,
  },
  {
    path: 'seller-push',
    component: OnboardingImplementationSellerPushComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OnboardingImplementationRoutingModule {}
